import {Basket} from "./BasketAB";
import {OfferSwitcher} from "./Card/OfferSwitcherAB";

export class Card {
    constructor() {
        this.onProductSubscribeSizes();
        this.onProductSubscribeSubmit();
        this.onOffersParametersSuccessClick();

        this.bindEntities();
    }
    onProductSubscribeSizes() {
        $('#admission').on('shown.bs.modal', function () {
            if ($('.js-unavailable-offers .size-table__item.active').length == 0){
                $('.js-unavailable-offers .size-table__item').first().addClass('active');
            }
        });

        $('.js-not-available-offer-size').off('click').on('click', function(){
            $('.js-unavailable-offers .js-offer-size').parent().removeClass('active');
            $('#admission').modal('show');
            $('.js-unavailable-offers .js-offer-size[data-offer-id="' + $(this).data('offer-id') + '"]').parent().addClass('active');
        });

        $('.js-unavailable-offers .js-offer-size').off('click').on('click', function(){
            $('.js-offer-size').parent().removeClass('active');
            $(this).parent().addClass('active');
        });
    }
    onProductSubscribeSubmit() {
        $('.js-product_subscribe').off('submit').on('submit', function (event) {
            event.preventDefault();

            let $this = $(this),
                button = $('.js-product_subscribe-button'),
                email = $this.find('#email').val(),
                id = $this.find('#id').val(),
                offer_id = $this.find('.size-table__item.active .js-offer-size').data('offer-id');

            if (!checkFormRequiredFields($this)) {
                return;
            }

            $('body').preloader('show');

            $.post($this.attr('action'), { id, email,offer_id }, ({ type, value }) => {
                const $modal = $this.closest('.modal');

                if (type === 'success') {
                    const $modalContent = $modal.find('.modal-content');
                    const $modalContentCopy = $modalContent.clone(true);
                    $modalContent.replaceWith($(value).find('.modal-content'));
                    $modal.one('hidden.bs.modal', () => {
                        $modal.find('.modal-content').replaceWith($modalContentCopy);
                    });

                    let switchText = button.data('switch-text'),
                        oldText = button.text();
                    button.text(switchText);
                    button.data('switch-text', oldText);
                    
                    // button.attr('disabled', true);
                    BX.Event.EventEmitter.emit('Mario.Card:subscribed', { id, email, offer_id });
                } else {
                    $this.closest('.modal').modal('hide');
                }

                $('body').preloader('hide');
            }, 'json');
        });
    }
    onOffersParametersSuccessClick() {
        $('.js-offers_parameters-success').on('click', function (event) {
            event.preventDefault();

            let $this = $(this),
                thisModal = $this.closest('.modal'),
                id = ($this.data('id')) ?
                    $this.data('id') :
                    thisModal.find('.js-product_offer-id').val();

            switch ($(this).data('type')) {
                case 'basket':
                    window.init_basket_add_modal();

                    Basket.add(id, () => { thisModal.modal('hide'); $('.js-add_to_basket_modal').modal('show') });

                    break;

                case 'fast_buy':
                    let modal = $('#fast-buy');

                    modal.find('.js-fast-order_id').val(id);

                    if (thisModal && thisModal.length > 0) {
                        thisModal.modal('hide');
                    }

                    modal.modal('show');
                    break;

                case 'combo':
                    window.init_basket_add_modal();

                    Basket.add_combo(id, () => { thisModal.modal('hide'); $('.js-add_to_basket_modal').modal('show') });

                    break;
            }
        });
    }
    bindEntities() {
        rebindBasketItemButtons();

        $('.js-offer-switcher').bindToEntity(OfferSwitcher);
    }

    static handleAddToBasketClick() {
        let modal = $('.js-add_to_basket_modal');

        modal.modal('show');

        if (modal.find("#add_to_basket-additional_products").length > 0) {
            dataLayer = window.dataLayer || [];
            $(".products-basket_modal__item").each((index, element) => {
                dataLayer.push({
                    'event': 'ee_impressions',
                    'ecommerce': {
                        'currencyCode': 'RUB',
                        'impressions': [JSON.parse($(element).find("input[name=data_layer]").val())]
                    }
                })
            });
        }
    }

    static handleAddToBasketProductClick(target) {
        let item = $(target).parent().parent(),
            productData = JSON.parse(item.find("input[name=data_layer]").val());
        dataLayer = window.dataLayer || [];

        dataLayer.push({
            event: 'productClick',
            ecommerce: {
                click: {
                    actionField: {'list': "modal"},
                    products: [{
                        'name': productData.name,
                        'id': productData.id,
                        'price': productData.price,
                        'brand': productData.brand,
                        'category': productData.category,
                        'variant': productData.variant,
                        'position': productData.position,
                        'dimension17': productData.dimension17,
                        'dimension3': productData.dimension3,
                        'metric6': productData.metric6
                    }]
                }
            }
        });
    }

    static handleAddToBasketFromModal(event) {
        let target = $(event.target), item = target.parent(),
            productData = JSON.parse(item.find("input[name=data_layer]").val());
        dataLayer = window.dataLayer || [];

        Basket.add( target.data('id'), () => target.text('Добавлено') );

        dataLayer.push({
            'event': 'addToCart',
            'ecommerce': {
                'currencyCode': 'RUB',
                'add': {
                    'products': [{
                        'name': productData.name || '',
                        'id': productData.id || '',
                        'price': productData.price || 0,
                        'brand': productData.brand || '',
                        'category': productData.category || '',
                        'variant': productData.variant || '',
                        'quantity': 1
                    }],
                    'actionField': {list: 'modal', action: 'add'}
                }
            }
        });
    }
}
